import { ReactComponent as BlogIcon } from "../Assets/newIcons/blog.svg";
import { ReactComponent as ProductIcon } from "../Assets/newIcons/product.svg";
import { ReactComponent as ComplianceIcon } from "../Assets/newIcons/compliance.svg";
import { ReactComponent as CaseStudyIcon } from "../Assets/newIcons/caseStudy.svg";
import { ReactComponent as LeadsIcon } from "../Assets/newIcons/leads.svg";
import { ReactComponent as JobIcon } from "../Assets/newIcons/job.svg";
import { ReactComponent as ApplicantIcon } from "../Assets/newIcons/applicants.svg";
import { ReactComponent as ServiceIcon } from "../Assets/newIcons/service.svg";
import { ReactComponent as HomeIcon } from "../Assets/newIcons/home.svg";
import { icon } from "@fortawesome/fontawesome-svg-core";

export const sidebar = [
  { path: "/", title: "Home", icon: HomeIcon, tooltip: "Home" },
  {
    path: "/blogs",
    title: "blog",
    index: true,
    icon: BlogIcon,
    tooltip: "Blog",
    add: false,
    addUrl: "/blog/create_blog",
  },
  {
    path: "/case-study",
    title: "caseStudy",
    icon: CaseStudyIcon,
    tooltip: "Case-Study",
    add: false,
    addUrl: "/case-study/create",
  },
  {
    path: "/service",
    title: "service page",
    icon: ComplianceIcon,
  },
  {
    title: "services",
    icon: ComplianceIcon,
    child: [
      {
        path: "/technology-page",
        title: "Technology Page",
        tooltip: "Technology Page",
      },
      {
        path: "/technology",
        title: "technology",
        icon: ServiceIcon,
        tooltip: "Technology",
        add: false,
        addUrl: "/services/add",
      },
      {
        path: "/solutions-page",
        title: "Solutions Page",
      },
      {
        path: "/solutions",
        title: "solutions",
        icon: ServiceIcon,
        tooltip: "Solutions",
        add: false,
        addUrl: "/services/add",
      },
      { path: "/staff-augmentation", title: "Staff Augmentation" },
      { path: "/dedicated-teams", title: "Dedicated Teams" },
      { path: "/software-outsourcing", title: "Software Outsourcing" },
    ],
  },
  {
    path: "/leads",
    title: "lead",
    icon: LeadsIcon,
    pageType: "table",
    table_head: [
      { title: "S.No", value: "s.no" },
      { title: "Name", value: "name" },
      { title: "Phone no.", value: "phone" },
      { title: "Email", value: "email" },
    ],
    body_keys: ["name", "phone", "email"],
    tooltip: "Leads",
    add: false,
  },
  { path: "/career", title: "career", icon: JobIcon },
  {
    path: "/jobs",
    title: "job",
    icon: JobIcon,
    pageType: "table",
    table_head: [],
    body_keys: [],
    tooltip: "Jobs",
    add: false,
    addUrl: "/jobs/create_job",
  },
  {
    path: "/applicants",
    title: "applicants",
    icon: ApplicantIcon,
    pageType: "table",
    table_head: [],
    body_keys: [],
    tooltip: "Applicants",
  },
  {
    path: "/products-page",
    icon: ProductIcon,
    title: "Products Page",
  },
  {
    path: "/products",
    icon: ProductIcon,
    title: "Products",
    tooltip: "Products",
  },
  {
    path: "/industry-page",
    icon: ProductIcon,
    title: "Industries Page",
    tooltip: "Industry Page",
  },
  {
    path: "/industries",
    icon: ProductIcon,
    title: "Industries",
    tooltip: "Industries",
  },
  {
    path: "/compliance",
    title: "compliance",
    icon: ComplianceIcon,
    pageType: "table",
    tooltip: "Compliance",
    add: false,
    addUrl: "/compliance/add",
  },
  { path: "/about", title: "about", icon: ComplianceIcon },
];
